import { forwardRef } from 'react';
import { Squares2X2Icon } from '@heroicons/react/24/outline';
import './course-panel-sheet.css';

/**
 * Abre el panel del curso en móvil, donde las tabs ya no caben junto al chat.
 * Lleva el conteo de gente en línea, el único dato del panel que se pierde
 * mientras está cerrado.
 */
export const CoursePanelTrigger = forwardRef(function CoursePanelTrigger(
    { onClick, onlineCount = 0, expanded = false, controls },
    ref,
) {
    return (
        <button
            ref={ref}
            type="button"
            className="course-panel-trigger"
            onClick={onClick}
            aria-label="Abrir panel del curso"
            aria-expanded={expanded}
            aria-controls={controls}
        >
            <Squares2X2Icon className="course-panel-trigger__icon" aria-hidden="true" />
            <span className="course-panel-trigger__label">Panel</span>

            {onlineCount > 0 ? (
                <span className="course-panel-trigger__online">
                    <span className="course-panel-trigger__dot" aria-hidden="true" />
                    <span className="course-panel-trigger__count">{onlineCount}</span>
                    <span className="sr-only">en línea</span>
                </span>
            ) : null}
        </button>
    );
});
